import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { mainRouteInitial } from "../../Data/Constant";
import {
  useBhajanMandaliTypeData,
  useElectionResultDashboardData,
  useGrantDashboardCount,
  useGrantVillageForDashboard,
  useGrantVillageWiseYojana,
  useGrantYojanaForDashboard,
  useGrantYojanaWiseVillage,
  useOverallDashboardCount,
  useVillageDashboard,
  useVillageWiseYojana,
  useYojanaForDashboard,
  useYojanaWiseVillage,
} from "../../API_Master/FetchAPI";
import BeneficiaryTable from "./BeneficiaryTable";
import "./DashboardUnique.css"; // CSS MODULE
import banner1 from "../../Assets/banner1.jpg";
import banner2 from "../../Assets/banner2.jpg";
import banner3 from "../../Assets/banner3.jpg";

import VS11 from "../../Assets/VidhanSabha/VS11.png";
import VS12 from "../../Assets/VidhanSabha/VS12.png";

import VS21 from "../../Assets/VidhanSabha/VS21.png";
import VS22 from "../../Assets/VidhanSabha/VS22.png";

import VS31 from "../../Assets/VidhanSabha/VS31.png";
import VS32 from "../../Assets/VidhanSabha/VS32.png";

import VS41 from "../../Assets/VidhanSabha/VS41.png";
import VS42 from "../../Assets/VidhanSabha/VS42.png";

import VS51 from "../../Assets/VidhanSabha/VS51.png";
import VS52 from "../../Assets/VidhanSabha/VS52.png";

import common from "../../Assets/VidhanSabha/common.png";

import { FaArrowLeft } from "react-icons/fa";
import SummaryCards from "./SummaryCards";
import SummaryCardShimmerEffect from "./SummaryCards/SummaryCardShimmerEffect";
import Tabs from "./Tabs";
import VillageDetailHeader from "./VillageDetailHeader"; // NEW
import VillageGrid from "./VillageGrid";
import YojnaDetailHeader from "./YojnaDetailHeader";
import YojnaGrid from "./YojnaGrid";
// import YojanaGridShimmerEffect from './YojnaGrid/YojanaGridShimmerEffect';
// import VillageGridShimmerEffect from './VillageGrid/VillageGridShimmerEffect';
import BhajanMandali from "./BhajanMandali";
import ElectionResultCard from "./ElectionResultCard";
import GrantDetailsTable from "./GrantDetailsTable";
import GrantSummaryCards from "./GrantSummaryCards";
import GrantSummaryCardShimmerEffect from "./GrantSummaryCards/GrantSummaryCardShimmerEffect";
import GrantVillageDashboardGrid from "./GrantVillageDashboardGrid";
import GrantVillageDetailHeader from "./GrantVillageDetailHeader";
import GrantVillageGrid from "./GrantVillageGrid";
import GrantVillageWiseYojanaDetailHeader from "./GrantVillageWiseYojanaDetailHeader";
import GrantVillageWiseYojanaGrid from "./GrantVillageWiseYojanaGrid";
import GrantVillageWiseYojnaDetailsTable from "./GrantVillageWiseYojnaDetailsTable";
import GrantYojnaDetailHeader from "./GrantYojnaDetailHeader";
import GrantYojnaGrid from "./GrantYojnaGrid";
import VillageDashboardGrid from "./VillageDashboardGrid";
import VillageWiseYojanaDetails from "./VillageWiseYojanaDetails";
import SakhiMandal from "./SakhiMandal";
import CycleYojna from "./CycleYojna";
// PHCAshaVarkal removed (page deleted)

import Anganwadi from "./Anganwadi";
import HalpatiYuvaSangathan from "./HalpatiYuvaSangathan";
import YuvaSangathan from "./YuvaSangathan";
import { numberToHindiWords } from "../../MethodMaster/JSXComponentMothod";

/* ------------------- STATIC DATA ------------------- */

export default function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedVS = location.state?.selectedVS;
  const vsName = location.state?.vsName;
  const Vidhansabha = location.state?.Vidhansabha; // 👈 ADD THIS

  console.log("Vidhansabha", Vidhansabha)

  const vsNameMap = {
    VS1: "388 Varanasi North",
    VS2: "389 Varanasi South",
    VS3: "390 Varanasi Cantonment",
    VS4: "387 Rohaniya",
    VS5: "391 Sevapuri",
  };

  const selectedConstituencyName = vsName || (selectedVS ? vsNameMap[selectedVS] : null);
  const COMMON_BANNERS = [common];

  const getBannerImages = () => {
    switch (selectedVS) {
      case "VS1":
        return [VS11, VS12, COMMON_BANNERS];
      case "VS2":
        return [VS21, VS22, COMMON_BANNERS];
      case "VS3":
        return [VS31, COMMON_BANNERS];
      case "VS4":
        return [VS41, COMMON_BANNERS];
      case "VS5":
        return [VS51, COMMON_BANNERS];
      // case "VS3":
      //   return [ VS31, VS32, COMMON_BANNERS];
      // case "VS4":
      //   return [ VS41, VS42, COMMON_BANNERS];
      // case "VS5":
      //   return [ VS51, VS52, COMMON_BANNERS];
      default:
        return [banner1, banner2, banner3];
    }
  };

  const bannerImages = getBannerImages();
  const totalSlides = bannerImages.length;

  const [tab, setTab] = useState("overall");
  // Infinite banner slider
  const [activeSlide, setActiveSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const sliderRef = useRef(null);
  const trackRef = useRef(null);

  // Auto-advance
  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setActiveSlide((prev) => prev + 1);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  // When we land on the clone (index === totalSlides), silently jump back to real index 0
  useEffect(() => {
    if (activeSlide === totalSlides) {
      const track = trackRef.current;
      if (!track) return;
      // Wait for the CSS transition to finish, then snap back
      const onTransitionEnd = () => {
        setIsTransitioning(false); // disable transition temporarily
        setActiveSlide(0); // jump to real slide 0
        track.removeEventListener("transitionend", onTransitionEnd);
      };
      track.addEventListener("transitionend", onTransitionEnd);
    }
    // Re-enable transition after the silent snap
    if (activeSlide === 0 && !isTransitioning) {
      // Give one paint cycle then restore transition
      requestAnimationFrame(() => setIsTransitioning(true));
    }
  }, [activeSlide, isTransitioning]);

  const [selYojna, setSelYojna] = useState(null);
  const [selVillage, setSelVillage] = useState(null);
  const [selVillageYojna, setSelVillageYojna] = useState(null);
  const { data: overAllYojnaData, isFetching: fetchingOverAllYojanaData } = useYojanaForDashboard(tab === "overall", Vidhansabha);
  const { data: grantYojnaData, isFetching: fetchingrantYojanaData } = useGrantYojanaForDashboard(tab === "grant");
  const { data: grantVillageData, isFetching: fetchingrantVillageData } = useGrantVillageForDashboard(tab === "grantvillage");
  const { data: overallDashboardCountData, isFetching: fetchingOverAllDashboardCountData } = useOverallDashboardCount(tab === "overall", Vidhansabha);
  const { data: electionResultDashboardData, isFetching: fetchingElectionResultDashboardData } = useElectionResultDashboardData(tab === "electionresult");
  const { data: grantDashboardCountData, isFetching: fetchingGrantDashboardCountData } = useGrantDashboardCount(tab === "grant" || tab === "grantvillage");
  const { data: yojanaWiseVillageData, isFetching: fetchingYojanaWiseVillage } = useYojanaWiseVillage(!!selYojna && tab === "overall", selYojna?.GramYojnaID || null, Vidhansabha);
  const { data: grantYojanaWiseVillageData, isFetching: fetchinggrantYojanaWiseVillage } = useGrantYojanaWiseVillage(
    !!selYojna && tab === "grant",
    selYojna?.GrantYojnaName || null,
  );
  const { data: grantVillageWiseYojanaData, isFetching: fetchinggrantVillageWiseYojana } = useGrantVillageWiseYojana(
    !!selVillage && tab === "grantvillage",
    selVillage?.VillageID || null,
  );
  const { data: villageDashboardData, isFetching: fetchingVillageDashboardData } = useVillageDashboard(tab === "village");
  const { data: VillageWiseYojanaData, isFetching: fetchingVillageWiseYojana } = useVillageWiseYojana(!!selVillage, selVillage?.VillageNameEnglish || null, Vidhansabha);

  const { data: bhajanMandaliDashboardData, isFetching: fetchingBhajanMandaliDashboardData } = useBhajanMandaliTypeData(tab === "bhajanMandali");

  console.log(VillageWiseYojanaData, "VillageWiseYojanaDataVillageWiseYojanaData");
  const reset = () => {
    setSelYojna(null);
    setSelVillage(null);
    setSelVillageYojna(null);
  };

  const goBack = () => {
    if (tab !== "grantvillage") {
      if (selVillageYojna) setSelVillageYojna(null);
      else if (selVillage) setSelVillage(null);
      else if (selYojna) setSelYojna(null);
      else navigate(`/${mainRouteInitial}/VidhanSabhaDashboard`);
    } else {
      if (selVillageYojna) setSelVillageYojna(null);
      else if (selYojna) setSelYojna(null);
      else if (selVillage) setSelVillage(null);
      else navigate(`/${mainRouteInitial}/VidhanSabhaDashboard`);
    }
  };
  const handleNavigateToMainTab = () => {
    reset();
    const currentTab = tab;
    setTab(currentTab);
  };

  // function numberToGujaratiWords(num) {
  //   if (num === 0) return "શૂન્ય";

  //   const map1To99 = {
  //     1: "એક",
  //     2: "બે",
  //     3: "ત્રણ",
  //     4: "ચાર",
  //     5: "પાંચ",
  //     6: "છ",
  //     7: "સાત",
  //     8: "આઠ",
  //     9: "નવ",
  //     10: "દસ",
  //     11: "અગિયાર",
  //     12: "બાર",
  //     13: "તેર",
  //     14: "ચૌદ",
  //     15: "પંદર",
  //     16: "સોળ",
  //     17: "સત્તર",
  //     18: "અઢાર",
  //     19: "ઓગણીસ",
  //     20: "વીસ",
  //     21: "એકવીસ",
  //     22: "બાવીસ",
  //     23: "તેઈસ",
  //     24: "ચોવીસ",
  //     25: "પચ્ચીસ",
  //     26: "છવીસ",
  //     27: "સત્તાવીસ",
  //     28: "અઠ્ઠાવીસ",
  //     29: "ઓગણત્રીસ",
  //     30: "ત્રીસ",
  //     31: "એકત્રીસ",
  //     32: "બત્રીસ",
  //     33: "તેત્રીસ",
  //     34: "ચોત્રીસ",
  //     35: "પાંત્રીસ",
  //     36: "છત્રીસ",
  //     37: "સાડત્રીસ",
  //     38: "અડત્રીસ",
  //     39: "ઓગણચાલીસ",
  //     40: "ચાલીસ",
  //     41: "એકતાલીસ",
  //     42: "બેતાલીસ",
  //     43: "તેતાલીસ",
  //     44: "ચુંમાલીસ",
  //     45: "પિસ્તાલીસ",
  //     46: "છેતાલીસ",
  //     47: "સડતાલીસ",
  //     48: "અડતાલીસ",
  //     49: "ઓગણપચાસ",
  //     50: "પચાસ",
  //     51: "એકાવન",
  //     52: "બાવન",
  //     53: "ત્રેપન",
  //     54: "ચોપન",
  //     55: "પંચાવન",
  //     56: "છપ્પન",
  //     57: "સત્તાવન",
  //     58: "અઠ્ઠાવન",
  //     59: "ઓગણસાઠ",
  //     60: "સાઠ",
  //     61: "એકસઠ",
  //     62: "બાસઠ",
  //     63: "ત્રેસઠ",
  //     64: "ચોસઠ",
  //     65: "પાંસઠ",
  //     66: "છાસઠ",
  //     67: "સડસઠ",
  //     68: "અડસઠ",
  //     69: "ઓગણસિત્તેર",
  //     70: "સિત્તેર",
  //     71: "એકોતેર",
  //     72: "બોતેર",
  //     73: "તોતેર",
  //     74: "ચુમોતેર",
  //     75: "પંચોતેર",
  //     76: "છોતેર",
  //     77: "સડોતેર",
  //     78: "અઠ્ઠોતેર",
  //     79: "ઓગણએંસી",
  //     80: "એંસી",
  //     81: "એક્યાસી",
  //     82: "બ્યાસી",
  //     83: "ત્ર્યાસી",
  //     84: "ચોર્યાસી",
  //     85: "પંચ્યાસી",
  //     86: "છ્યાસી",
  //     87: "સડ્યાસી",
  //     88: "અઠ્ઠ્યાસી",
  //     89: "ઓગણનેવું",
  //     90: "નેવું",
  //     91: "એકાણું",
  //     92: "બાણું",
  //     93: "ત્રાણું",
  //     94: "ચોરાણું",
  //     95: "પંચાણું",
  //     96: "છાણું",
  //     97: "સત્તાણું",
  //     98: "અઠ્ઠાણું",
  //     99: "નવાણું",
  //   };

  //   const units = [
  //     { value: 1e13, label: "ખરબ" },
  //     { value: 1e11, label: "અરબ" },
  //     { value: 1e9, label: "કરોડ" },
  //     { value: 1e7, label: "લાખ" },
  //     { value: 1e5, label: "હજાર" },
  //     { value: 100, label: "સો" },
  //   ];

  //   let words = "";

  //   for (const unit of units) {
  //     if (num >= unit.value) {
  //       const count = Math.floor(num / unit.value);
  //       words += numberToGujaratiWords(count) + " " + unit.label + " ";
  //       num %= unit.value;
  //     }
  //   }

  //   if (num > 0) {
  //     words += map1To99[num];
  //   }

  //   return words.trim();
  // }

  console.log("checkingTheValueOfGujaratiWords", numberToHindiWords(100));
  return (
    <div className="w-100">
      <Tabs
        active={tab}
        onChange={(t) => {
          setTab(t);
          reset();
        }}
      />
      <div className={"govdash-container"}>
        {/* ===== AUTO SCROLL IMAGE BANNER ===== */}
        {/* <div className="govdash-bannerSlider" ref={sliderRef}>
          <div
            className="govdash-bannerTrack"
            style={{ transform: `translateX(-${activeSlide * 100}%)` }}
          >
            {bannerImages?.map((img, i) => (
              <div key={i} className="govdash-bannerSlide">
                <img src={img} alt={`banner-${i + 1}`} className="govdash-bannerImg" />
              </div>
            ))}
          </div>
          <div className="govdash-bannerDots">
            {bannerImages?.map((_, i) => (
              <button
                key={i}
                className={`govdash-bannerDot${activeSlide === i ? " active" : ""}`}
                onClick={() => setActiveSlide(i)}
              />
            ))}
          </div>
        </div> */}

        <div className="govdash-bannerSlider" ref={sliderRef}>
          {/* Track: real slides + 1 cloned first slide at end for infinite loop */}
          <div
            ref={trackRef}
            className="govdash-bannerTrack"
            style={{
              transform: `translateX(-${activeSlide * 100}%)`,
              transition: isTransitioning ? "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)" : "none",
            }}
          >
            {bannerImages?.map((img, index) => (
              <div key={index} className="govdash-bannerSlide">
                <img src={img} alt={`banner-${index + 1}`} className="govdash-bannerImg" />
              </div>
            ))}

            {/* Clone of first banner for seamless loop */}
            <div className="govdash-bannerSlide">
              <img src={bannerImages[0]} alt="banner-clone" className="govdash-bannerImg" />
            </div>
          </div>

          {/* Dots — show real slide index (clone maps back to 0) */}
          <div className="govdash-bannerDots">
            {bannerImages?.map((_, i) => (
              <button
                key={i}
                className={`govdash-bannerDot${activeSlide % totalSlides === i ? " active" : ""}`}
                onClick={() => {
                  setIsTransitioning(true);
                  setActiveSlide(i);
                }}
              />
            ))}
          </div>
        </div>

        {/* Title Bar with Back Button and Varanasi Vidhansabha on the same line */}
        <div className={"govdash-titleRow"}>
          <button id="govdash-back-btn" className={"govdash-backBtn"} onClick={goBack}>
            <FaArrowLeft className="govdash-backIcon" />
            <span>Back</span>
          </button>
          <h1 className={"govdash-mainHeading"}>{selectedConstituencyName ? `Varanasi - ${selectedConstituencyName}` : "Varanasi"}</h1>
        </div>
        <div className={"govdash-content"}>
          {/* Back Button */}
          {/* ====================== DYNAMIC HEADER ====================== */}
          {(selYojna || selVillage || selVillageYojna) && (
            <div className={"govdash-headerWrapper"}>
              {/* Case 1: Only Yojna selected (Overall tab) */}
              {selYojna &&
                !selVillage &&
                !selVillageYojna &&
                (tab == "grant" ? (
                  <GrantYojnaDetailHeader yojna={selYojna} handleNavigateToMainTab={handleNavigateToMainTab} />
                ) : (
                  <YojnaDetailHeader yojna={selYojna} handleNavigateToMainTab={handleNavigateToMainTab} />
                ))}

              {/* Case 2: Village selected, no Yojna clicked yet */}
              {selVillage &&
                !selVillageYojna &&
                tab != "grantvillage" &&
                (tab == "grant" ? (
                  <GrantVillageDetailHeader village={selVillage} handleNavigateToMainTab={handleNavigateToMainTab} />
                ) : (
                  <VillageDetailHeader village={selVillage} handleNavigateToMainTab={handleNavigateToMainTab} tab={tab} />
                ))}
              {selVillage && tab == "grantvillage" && !selYojna && <GrantVillageDetailHeader village={selVillage} handleNavigateToMainTab={handleNavigateToMainTab} />}
              {selVillage && tab == "grantvillage" && selYojna && <GrantVillageWiseYojanaDetailHeader yojna={selYojna} handleNavigateToMainTab={handleNavigateToMainTab} />}

              {/* Case 3: Used Yojna clicked in Village tab → Show YOJNA header */}
              {selVillageYojna && selVillageYojna && <YojnaDetailHeader yojna={selVillageYojna.yojna} handleNavigateToMainTab={handleNavigateToMainTab} />}
            </div>
          )}

          {/* ====================== OVERALL TAB ====================== */}
          {tab === "overall" && !selYojna && !selVillage && (
            <>
              {fetchingOverAllDashboardCountData ? (
                <SummaryCardShimmerEffect />
              ) : (
                <SummaryCards
                  voters={overallDashboardCountData?.[0]?.OverallVoterCount || "0"}
                  amount={overallDashboardCountData?.[0]?.TotalAmount || "0"}
                  labharti={overallDashboardCountData?.[0]?.BeneficialCount || "0"}
                  labharthiLabh={overallDashboardCountData?.[0]?.TotalLabharthiLabh || "0"}
                />
              )}
              <YojnaGrid overallDashboardCountData={overallDashboardCountData} yojnas={overAllYojnaData} onSelect={setSelYojna} isLoading={fetchingOverAllYojanaData} />
            </>
          )}
          {tab === "electionresult" && (
            <>
              {/* {fetchingOverAllDashboardCountData ? <SummaryCardShimmerEffect /> : */}
              <ElectionResultCard electionResultDashboardData={electionResultDashboardData} fetchingElectionResultDashboardData={fetchingElectionResultDashboardData} />
              {/* } */}

              {/* */}
            </>
          )}

          {tab === "bhajanMandali" && (
            <>
              <BhajanMandali bhajanMandaliDashboardData={bhajanMandaliDashboardData} fetchingBhajanMandaliDashboardData={fetchingBhajanMandaliDashboardData} />
            </>
          )}
          {tab === "sakhiMandal" && (
            <>
              <SakhiMandal />
            </>
          )}
          {tab === "cycleYojna" && (
            <>
              <CycleYojna />
            </>
          )}
          {/* PHCAshaVarkal removed */}
          {tab === "anganwadi" && (
            <>
              <Anganwadi />
            </>
          )}
          {tab === "halpatiYuvaSangathan" && (
            <>
              <HalpatiYuvaSangathan />
            </>
          )}
          {tab === "yuvaSangathan" && (
            <>
              <YuvaSangathan />
            </>
          )}
          {tab === "grant" && !selYojna && !selVillage && (
            <>
              {fetchingGrantDashboardCountData ? (
                <GrantSummaryCardShimmerEffect />
              ) : (
                <GrantSummaryCards amount={grantDashboardCountData?.[0]?.OverallAmount || ""} labhartiVillage={grantDashboardCountData?.[0]?.OverallVillageCount || ""} />
              )}
              <GrantYojnaGrid overallDashboardCountData={grantDashboardCountData} yojnas={grantYojnaData} onSelect={setSelYojna} isLoading={fetchingrantYojanaData} />
            </>
          )}
          {tab === "grantvillage" && !selYojna && !selVillage && (
            <>
              {fetchingGrantDashboardCountData ? (
                <GrantSummaryCardShimmerEffect />
              ) : (
                <GrantSummaryCards amount={grantDashboardCountData?.[0]?.OverallAmount || ""} labhartiVillage={grantDashboardCountData?.[0]?.OverallVillageCount || ""} />
              )}
              <GrantVillageDashboardGrid
                overallDashboardCountData={grantDashboardCountData}
                villages={grantVillageData}
                onSelect={setSelVillage}
                isLoading={fetchingrantVillageData}
              />
            </>
          )}

          {/* Yojna → Villages */}
          {tab === "overall" && selYojna && !selVillage && (
            <>{<VillageGrid selYojna={selYojna} villages={yojanaWiseVillageData} onSelect={setSelVillage} isLoading={fetchingYojanaWiseVillage} />}</>
          )}
          {tab === "grant" && selYojna && !selVillage && (
            <>{<GrantVillageGrid selYojna={selYojna} villages={grantYojanaWiseVillageData} onSelect={setSelVillage} isLoading={fetchinggrantYojanaWiseVillage} />}</>
          )}

          {tab === "grantvillage" && selVillage && !selYojna && (
            <>{<GrantVillageWiseYojanaGrid selVillage={selVillage} yojana={grantVillageWiseYojanaData} onSelect={setSelYojna} isLoading={fetchinggrantVillageWiseYojana} />}</>
          )}

          {/*Overall → Village -> Beneficiary list */}
          {tab === "overall" && selVillage && !selVillageYojna && (
            <BeneficiaryTable tab={tab} selVillage={selVillage} selYojna={selYojna} title={`Labharthi – ${selYojna?.GramYojnaName}`} Vidhansabha={Vidhansabha} />
          )}
          {tab === "grant" && selVillage && selYojna && <GrantDetailsTable selVillage={selVillage} selYojna={selYojna} title={`Grant Details - ${selYojna?.GrantYojnaName}`} />}
          {tab === "grantvillage" && selVillage && selYojna && (
            <GrantVillageWiseYojnaDetailsTable selVillage={selVillage} selYojna={selYojna} title={`Grant Details - ${selVillage?.Village}`} />
          )}
          {/* ====================== VILLAGE TAB ====================== */}
          {tab === "village" && !selVillage && <VillageDashboardGrid isLoading={fetchingVillageDashboardData} villages={villageDashboardData} onSelect={setSelVillage} />}

          {/* Village → Yojna List */}
          {tab === "village" && selVillage && !selVillageYojna && (
            <VillageWiseYojanaDetails
              VillageWiseYojanaData={VillageWiseYojanaData}
              selVillage={selVillage}
              setSelVillageYojna={setSelVillageYojna}
              fetchingVillageWiseYojana={fetchingVillageWiseYojana}
            />
          )}

          {/* Beneficiary List – from Village → Used Yojna */}
          {tab === "village" && selVillageYojna && (
            <BeneficiaryTable tab={tab} selVillage={selVillageYojna.village} selYojna={selVillageYojna.yojna} title={`Labharthi – ${selVillage.VillageNameEnglish}`} />
          )}
        </div>
      </div>
    </div>
  );
}
